import { useEffect, useState } from 'react';
import { Content, Table } from 'components';
import { Empty, Image } from 'antd';
import { stringToMoneyFormat } from 'utils';
import { Link } from 'react-router-dom';
import moment from 'moment';

const ProductTable = ({ selectedTag }) => {
  const [productList, setProductList] = useState([]);

  useEffect(() => {
    if (selectedTag && Array.isArray(selectedTag.products)) {
      setProductList(
        selectedTag.products.map((product, index) => {
          // const thumbnailFile = Array.isArray(product.product_file) ? product.product_file.find((item) => item.type === 'THUMBNAIL') : '';
          // const thumbnailUrl = thumbnailFile ? `${process.env.REACT_APP_STORE_URL}/${thumbnailFile.file_url}` : '';
          return {
            key: product.product_id,
            no: index + 1,
            code: product.product_code,
            name: product.product_name,
            num: product.num,
            price: product.price,
            created: moment.unix(product.created_at).format('YYYY-MM-DD'),
          };
        }),
      );
    }
  }, [selectedTag]);

  return (
    <Content
      maxWidth={'100%'}
      borderRadius={4}
      padding={20}
      style={{ height: '100%' }}
    >
      <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
        태그 별 상품 총 <span>{productList.length}</span>건
      </h4>
      <Table
        data={productList}
        columns={[
          {
            title: 'No',
            key: 'no',
          },
          {
            title: '상품코드',
            key: 'code',
          },
          {
            title: '상품명',
            key: 'name',
            render: (item, product) => {
              return <Link to={`/product/list/${product.key}`}>{item}</Link>;
            },
          },
          {
            title: '재고수량',
            key: 'num',
            render: (item) => `${item} EA`,
          },
          {
            title: '판매가',
            key: 'price',
            render: (item) => `${stringToMoneyFormat(item)} 원`,
          },
          {
            title: '등록일',
            key: 'created',
          },
        ]}
      />
    </Content>
  );
};

export default ProductTable;
